/** Stable drawer names for `Drawer name=` + `useDrawerContext` */

export const TASK_CREATE_DRAWER = 'task-create-drawer';
export const LEAD_CREATE_DRAWER = 'lead-create-drawer';
export const PIPELINE_CREATE_DRAWER = 'pipeline-create-drawer';
export const PROJECT_CREATE_DRAWER = 'project-create-drawer';
export const TASK_VIEW_REVENUE_DRAWER = 'task-view-revenue-drawer';
export const OPPORTUNITY_LINKED_PRODUCTS_DRAWER =
  'opportunity-linked-products-drawer';
export const TEAMS_ADD_TEAM_MEMBER_DRAWER = 'teams-add-team-member-drawer';
export const TEAMS_CREATE_OR_EDIT_DRAWER = 'teams-create-or-edit-drawer';

export const MEETING_ASSIGN_CONTACT_DRAWER = 'meeting-assign-contact-drawer';
export const MEETING_ADD_PARTICIPANT_DRAWER = 'meeting-add-participant-drawer';
export const MEETING_ASSIGN_COMPANY_DRAWER = 'meeting-assign-company-drawer';
export const MEETING_SELECT_CONTACT_COMPANY_DRAWER =
  'meeting-select-contact-company-drawer';
export const MEETING_PARTICIPANT_CONTACT_DRAWER =
  'meeting-participant-contact-drawer';

export const AI_INSIGHT_TAG_CATEGORY_DRAWER = 'ai-insight-tag-category-drawer';
export const AI_INSIGHT_ADD_TAG_DRAWER = 'ai-insight-add-tag-drawer';

export const SENTIMENT_CONFIG_DRAWER = 'sentiment-config-drawer';
export const SENTIMENT_CONFIG_DELETE_MODAL = 'sentiment-config-delete-modal';

export const TEAMS_EDIT_FUNCTIONS_DRAWER = 'teams-edit-functions-drawer';
export const TEAMS_DELETE_INDIVIDUAL_MODAL = 'teams-delete-individual-modal';
export const ROLE_USERS_CHANGE_ROLE_DRAWER = 'role-users-change-role-drawer';
export const CALL_GROUPS_CREATE_OR_EDIT_DRAWER =
  'call-groups-create-or-edit-drawer';
export const CALL_GROUPS_ADD_USER_DRAWER = 'call-groups-add-user-drawer';

export const SUB_PRODUCT_CONFIGURATION_DRAWER =
  'sub-product-configuration-drawer';

export const COMPANY_BRANDING_DRAWER = 'company-branding-drawer';
export const COMPANY_COMMUNICATION_DRAWER = 'company-communication-drawer';
export const COMPANY_BANK_ACCOUNT_DRAWER = 'company-bank-account-drawer';
export const COMPANY_CONFIGURATION_DRAWER = 'company-configuration-drawer';
export const COMPANY_CONTRACT_DELETE_MODAL = 'company-contract-delete-modal';

/** Phase 1 — tasks send-mail / emails, quotes, invoices */
export const TASK_SEND_EMAIL_MODAL = 'task-send-email-modal';
export const TASK_SEND_EMAIL_DRAWER = 'task-send-email-drawer';
export const TASK_VIEW_EMAILS_DRAWER = 'task-view-emails-drawer';
export const TASK_VIEW_EMAIL_THREAD_MODAL = 'task-view-email-thread-modal';
export const TASK_VIEW_EMAIL_THREAD_DRAWER = 'task-view-email-thread-drawer';
export const MAIL_MESSAGE_DRAWER = 'mail-message-drawer';
export const MAIL_LINK_DRAWER = 'mail-link-drawer';
export const MAIL_FILTER_DRAWER = 'mail-filter-drawer';
export const CALENDAR_CREATE_DRAWER = 'calendar-create-drawer';

export const COMPANY_SEND_EMAIL_MODAL = 'company-send-email-modal';
export const COMPANY_SEND_EMAIL_DRAWER = 'company-send-email-drawer';
export const QUOTES_CREATE_DRAWER = 'quotes-create-drawer';
export const QUOTE_DETAILS_EDIT_DRAWER = 'quote-details-edit-drawer';
export const QUOTE_ITEMS_ADD_EDIT_DRAWER = 'quote-items-add-edit-drawer';
export const QUOTE_SEND_TO_CLIENT_DRAWER = 'quote-send-to-client-drawer';
export const INVOICE_DOCUMENTS_DRAWER = 'invoice-documents-drawer';
export const INVOICE_CREATE_DRAWER = 'invoice-create-drawer';
export const INVOICE_ITEMS_ADD_EDIT_DRAWER = 'invoice-items-add-edit-drawer';
export const INVOICE_SEND_TO_CLIENT_DRAWER = 'invoice-send-to-client-drawer';

/** PR1 — shared drawer surfaces */
export const LINKED_INDIVIDUALS_DRAWER = 'linked-individuals-drawer';
export const GENERIC_DOCUMENTS_DRAWER = 'generic-documents-drawer';
export const NOTES_DRAWER = 'notes-drawer';
export const ACTIVITY_LOG_DRAWER = 'activity-log-drawer';
export const DATATABLE_FILTER_DRAWER = 'datatable-filter-drawer';

/** Phase 2 — task drawers */
export const TASK_VIEW_NOTES_DRAWER = 'task-view-notes-drawer';
export const TASK_VIEW_ACTIVITY_DRAWER = 'task-view-activity-drawer';
export const TASK_LINKED_CONTACT_DRAWER = 'task-linked-contact-drawer';
export const TASK_DISTRIBUTION_DRAWER = 'task-distribution-drawer';
export const TASK_FILTERS_DRAWER = 'task-filters-drawer';
/** BUGS-2914 — bulk edit on the deals list */
export const DEALS_BULK_EDIT_DRAWER = 'deals-bulk-edit-drawer';

/** Phase 4 — audiences drawers */
export const AUDIENCES_FILTER_DRAWER = 'audiences-filter-drawer';
export const AUDIENCES_EDIT_DRAWER = 'audiences-edit-drawer';
export const AUDIENCES_BULK_EDIT_DRAWER = 'audiences-bulk-edit-drawer';
export const AUDIENCES_ADD_PROPERTY_DRAWER = 'audiences-add-property-drawer';
export const AUDIENCES_PREVIEW_FILTER_DRAWER =
  'audiences-preview-filter-drawer';
export const AUDIENCES_ADD_CUSTOM_FIELD_DRAWER =
  'audiences-add-custom-field-drawer';

/** Phase 6 — market-news drawers */
export const MARKET_NEWS_FILTER_DRAWER = 'market-news-filter-drawer';
export const MARKET_NEWS_CREATE_EDIT_DRAWER = 'market-news-create-edit-drawer';
export const MARKET_NEWS_CONTACT_DRAWER = 'market-news-contact-drawer';
export const MARKET_NEWS_SHARE_DRAWER = 'market-news-share-drawer';

/** Phase 5 — fee-structure drawers */
export const FEE_CREATE_CATEGORY_DRAWER = 'fee-create-category-drawer';
export const FEE_CREATE_VERSION_DRAWER = 'fee-create-version-drawer';
export const FEE_DUPLICATE_VERSION_DRAWER = 'fee-duplicate-version-drawer';
export const FEE_ADD_TRANSACTION_DRAWER = 'fee-add-transaction-drawer';
export const FEE_EXCEPTION_DRAWER = 'fee-exception-drawer';

/** Phase 7 — billing, policies, company data */
export const QUOTE_CONVERT_TO_INVOICE_DRAWER =
  'quote-convert-to-invoice-drawer';
export const FLIGHTDECK_CONVERT_TO_INVOICE_DRAWER =
  'flightdeck-convert-to-invoice-drawer';
export const FLIGHTDECK_INVOICE_CREATE_DRAWER =
  'flightdeck-invoice-create-drawer';
export const POLICY_DOCUMENTS_DRAWER = 'policy-documents-drawer';
export const OFF_PLATFORM_POLICY_CREATE_EDIT_DRAWER =
  'off-platform-policy-create-edit-drawer';
export const COMPANY_DATA_DRAWER = 'company-data-drawer';
export const COMPANY_OPPORTUNITY_SNAPSHOT_DRAWER =
  'company-opportunity-snapshot-drawer';
export const COMPANY_OPPORTUNITY_SIZE_SCALE_DRAWER =
  'company-opportunity-size-scale-drawer';

/** Phase 8 — platform leftovers */
export const OFFLINE_PRODUCT_ADD_DRAWER = 'offline-product-add-drawer';
export const OFFLINE_PRODUCT_EDIT_PERCENTAGE_DRAWER =
  'offline-product-edit-percentage-drawer';
export const DOCUMENT_TEMPLATE_CREATE_DRAWER =
  'document-template-create-drawer';
export const DOCUMENT_TEMPLATE_USE_DRAWER = 'document-template-use-drawer';
export const WORKFLOWS_NO_PIPELINES_DRAWER = 'workflows-no-pipelines-drawer';
export const PROVIDERS_DRAWER = 'providers-drawer';
export const MEMBERSHIP_SUBSCRIBE_DRAWER = 'membership-subscribe-drawer';
export const INDIVIDUALS_DRAWER = 'individuals-drawer';
export const TERMS_AND_CONDITIONS_DRAWER = 'terms-and-conditions-drawer';
export const COMPANY_SEND_EMAIL_LEGACY_DRAWER =
  'company-send-email-legacy-drawer';
export const INDIVIDUAL_SEND_EMAIL_DRAWER = 'individual-send-email-drawer';
export const CONTACT_PRIMARY_DRAWER = 'contact-primary-drawer';
export const CONTACT_DETAILS_DRAWER = 'contact-details-drawer';
export const LINKED_COMPANIES_DRAWER = 'linked-companies-drawer';
export const UPDATE_PROFILE_DRAWER = 'update-profile-drawer';
export const PIPELINE_MISSIONS_CREATE_UPDATE_DRAWER =
  'pipeline-missions-create-update-drawer';
/** Objectives drawers */
export const OBJECTIVES_GOAL_DRAWER = 'objectives-goal-drawer';
export const OBJECTIVES_KEY_OBJECTIVE_DRAWER =
  'objectives-key-objective-drawer';
export const OBJECTIVES_PROCESS_DRAWER = 'objectives-process-drawer';

/** Market Intelligence drawers */
export const MARKETPLACE_INTELLIGENCE_CREATE_STUDY_DRAWER =
  'marketplace-intelligence-create-study-drawer';
export const MARKETPLACE_INTELLIGENCE_CREATE_SCHEDULE_DRAWER =
  'marketplace-intelligence-create-schedule-drawer';
export const MI_CREATE_SCHEDULE_DRAWER =
  MARKETPLACE_INTELLIGENCE_CREATE_SCHEDULE_DRAWER;
